import { APIService } from "shared/services";
import { API_ENDPOINTS } from "shared/constants";
import { IJSONAPIItem, IJSONAPICollection, IInfoBlockItemType, IInfoBlockItem } from "shared/types";

interface IJSONAPIInfoBlockItem {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIInfoBlockItemCollection {
  [IInfoBlockItem.contact]?: IJSONAPIInfoBlockItem;
  [IInfoBlockItem.place]?: IJSONAPIInfoBlockItem;
  [IInfoBlockItem.file]?: IJSONAPIInfoBlockItem;
  [IInfoBlockItem.image]?: IJSONAPIInfoBlockItem;
  meta: {
    [key: string]: IJSONAPIItem;
  };
}

export class InfoBlockItemService {
  static getInfoBlockItems = (
    type: IInfoBlockItem,
    queryParams?: string | { [key: string]: string | number }
  ): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        const data = await APIService.get({
          path: API_ENDPOINTS.INFO_BLOCK_ITEMS(type),
          data: queryParams,
        });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });

  static getInfoBlockItem = (id: string, type: IInfoBlockItem): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        const data = await APIService.get({
          path: API_ENDPOINTS.INFO_BLOCK_ITEM(id, type),
        });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });

  static createInfoBlockItem = (
    data: Partial<IInfoBlockItemType>,
    type: IInfoBlockItem
  ): Promise<IJSONAPICollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.INFO_BLOCK_ITEMS(type),
          data,
        });

        resolve(response);
      } catch (error) {
        reject(error);
      }
    });

  static editInfoBlockItem = (
    id: string,
    data: Partial<IInfoBlockItemType>,
    type: IInfoBlockItem
  ): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.INFO_BLOCK_ITEM(id, type),
          data,
        });

        resolve(response);
      } catch (error) {
        reject(error);
      }
    });

  static deleteInfoBlockItem = (id: string, type: IInfoBlockItem): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.INFO_BLOCK_ITEM(id, type),
        });

        resolve();
      } catch (error) {
        reject(error);
      }
    });
}
